import { ParseSpec } from 'prosemirror-markdown';
import { MarkSpec } from 'prosemirror-model';

import { BaseExtension, EditorOptions, extensionType } from '@lyearn/lygo-core';

import { markInputRule } from '../../utils';
import plugins from './plugins';

const UNDERLINE_NODE_NAME = 'underline';
const UNDERLINE_REGEX = /(?:__)([^_]+)(?:__)$/;

export default class Underline extends BaseExtension {
  get schema(): MarkSpec {
    return {
      parseDOM: [{ tag: 'u' }],
      toDOM: () => ['u', 0],
    };
  }

  get type(): string {
    return extensionType.mark;
  }

  get name(): string {
    return UNDERLINE_NODE_NAME;
  }

  parseMarkdown(): void | ParseSpec {
    return {
      mark: UNDERLINE_NODE_NAME,
    };
  }

  inputRules({ schema }: EditorOptions) {
    return [markInputRule(UNDERLINE_REGEX, schema.marks.underline)];
  }

  plugins = plugins;
}
